import React from "react";

import { NavTop } from "./NavTop";
import { Main } from "./Main";

export const App = () => {
  return (
    <div>
      <NavTop />
      <Main />
    </div>
  );
};
